import { useEffect, useState } from "react";
import { Navigate, Outlet, useLocation, useNavigate, useParams } from "react-router-dom";
import { ISelectList } from "../../components/Contentbar/ContentSide/ContentSideComp";
import Navbar, { SearchMode } from "../../components/navbar/Navbar";
import SideBar, { isValidUserPendencies } from "../../components/Sidebar/sidebar";
import { useAuth } from "../../context/AuthProvider/useAuth";
import { useProfile } from "../../context/ProfileProvider/useProfile";
import { Organization } from "../../model/OrganizationModel";
import { WorkSpace } from "../../model/WorkSpaceModel";
import { Api } from "../../services/api";
import { AxiosRequestConfig } from 'axios';
import {FileUploader} from "../Upload/FileUploader";
import {GetUserPendenciesBoolean} from "../../services/ValidationRuleService"
import WaitPage from "../ErroPage/WaitPage"
import { ContentbarProps } from "../../components/Contentbar/ContentSide/ContentSideComp";
import { handleAllowed } from "../../functions/handleAllowed";
import { SetOrganizationNameLocalStorage } from "../../context/AuthProvider/util";
import style from "./ILayoutProtected.module.css";
import { CreateUserLoggedByOrg, GetOneOrganization, GetOrganizationSigntureInformation } from "../../services/OrganizationServices";
import { AddLastUrlPathLocalStorage, AddOrganizationLocalStorage, RemoveOrganizationLocalStorage, RemoveWorkspaceLocalStorage } from "../PublicLayout/RedirectManager";
import { GetOneWorkSpace } from "../../services/WorkSpaceServices";
import { KeyDriveBreadcrumb } from "../../components/KeydriveComponents/Breadcrumb/KeyDriveBreadcrumb";
import { Box, LinearProgress, Paper, Step, StepLabel, Stepper } from "@mui/material";
import { EnumSignture, KeydrivePlan } from "../../model/UserModel";
import { CheckCircle, Payment, Unsubscribe } from "@mui/icons-material";
import FreeSoftwareAlert from "../../components/FreeSoftwareAlert/FreeSoftwareAlert";
import CancelDueAlert from "../../components/CancelDueAlert/CancelDueAlert";
import { KeyDriveDialog } from "../../components/KeydriveComponents/Dialog/KeyDriveDialog";
import { useTranslation } from "react-i18next";
import { AddressElement, CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import { KeyDriveBodyMin } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMin";
import { LoadingStep } from "../Plan/ChoosePlan";
import { UpdatePaymentMethodAsync } from "../../services/PaymentService";
import { KeyDriveBodyMax } from "../../components/KeydriveComponents/Fonts/Body/KeyDriveBodyMax";

const ILayoutProtected = (props: any) => {
  const auth = useAuth();
  const profile = useProfile();
  const { nameOrg, idWorkspace, idFile } = useParams();
  const [isOrganizationVisible, setOrganizationVisible] =
    useState<boolean>(false);
  const [isWorkspaceVisible, setWorkspaceVisible] = useState<boolean>(false);
  const [isUsersVisible, setUsersVisible] = useState<boolean>(false);
  const [isGroupspaceVisible, setGroupspaceVisible] = useState<boolean>(false);
  const [feedTrackerVisible, setFeedTrackerVisible] = useState<boolean>(false);
  const [sharedItemVisible, setSharedItemVisible] = useState<boolean>(true);
  const [isUserPendencies, setUserPendencies] = useState<isValidUserPendencies>();
  const [isDocuemntTypeVisible, setDocuemntTypeVisible] =
    useState<boolean>(false);
  const [isValidationRuleVisible, setValidationRuleVisible] =
  useState<boolean>(false);
  const [searchboxFocus, setSearchboxFocus] = useState<boolean>(false);

  const [organization, setOrganization] = useState<Organization | undefined>(
    undefined
  );
  const [workSpace, setWorkSpace] = useState<WorkSpace | undefined>(
    undefined
  );
  const [orgWorkSpace, setOrgWorkSpace] = useState<WorkSpace | undefined>(
    undefined
  );
  const [orgValidationWorkSpace, setOrgValidationWorkSpace] = useState<WorkSpace | undefined>(
    undefined
  );
  const [openKeyDriveDialog, setKeyDriveDialog] = useState<boolean>(false);
  const [openCancelKeyDriveDialog, setCancelKeyDriveDialog] = useState<boolean>(false);
  const [openUpdateMethodDialog, setUpdateMethodDialog] = useState<{ open: boolean, severity: number }>({ open: false, severity: 0 });
  const [fileVisible, setFileVisible] = useState<boolean>(false);
  const [contentbar, setContentbar] = useState<ContentbarProps<ISelectList>[]>([]);
  const [hasBeenUpdated, setHasBeenUpdated] = useState<boolean>(false);
  const [isAdminConsolePage, setIsAdminConsolePage] = useState<boolean>(false);
  const [newLayoutProtected, setNewLayoutProtected] = useState<boolean>(false);
  const location = useLocation();
  const navegate = useNavigate();
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [idSelectd, setIdSelectd] = useState<number|undefined>(undefined);
  const { t } = useTranslation();
  const [openEditPaymentMethodModal, setOpenEditPaymentMethodModal] = useState<boolean>(false);
  const stripe = useStripe();
  const elements = useElements();
  const [loadingModal, setLoadingModal] = useState<boolean>(false);
  const [successModal, setSuccessModal] = useState<boolean>(false);
  const [loadingStep, setLoadingStep] = useState<LoadingStep>(null);
  const [errorModal, setErrorModal] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(undefined);
  const [loadSignture, setLoadSignture] = useState<boolean>(false);

  useEffect(() => {
    if (nameOrg == undefined) return;

    setLoadSignture(true);
    profile.setSigntureInformation(undefined);
    GetOrganizationSigntureInformation(nameOrg)
    .then(data => {
      profile.setSigntureInformation(data);
    })
    .catch((err) => {
      console.log(err.response.data)
    })
    .finally(() => {
      setLoadSignture(false);
    })
  }, [nameOrg])

  useEffect(() => {
    var url =`/${nameOrg}/${idWorkspace}/temporality`

    if(idSelectd == 9 && window.location.pathname != url){
      setIdSelectd(undefined)
    }
  },[idSelectd])

  useEffect(() => {
    if (!profile.adminSystem) {

      if (profile.signtureInformation?.signture == EnumSignture.PaymentFailedOneAlert) {
        setUpdateMethodDialog({
          open: true,
          severity: 1
        });
        return;
      }

      if (profile?.signtureInformation?.signture == EnumSignture.PaymentFailedOneWarning) {
        setUpdateMethodDialog({
          open: true,
          severity: 2
        });
        return;
      }

      if (profile?.signtureInformation?.signture == EnumSignture.PaymentFailedOneCritical) {
        setUpdateMethodDialog({
          open: true,
          severity: 3
        });
        return;
      }

      if (profile?.signtureInformation?.signture == EnumSignture.Canceled && !location.pathname.includes("plans")) {
        setCancelKeyDriveDialog(true);
      }
      else if (profile?.signtureInformation?.signture == EnumSignture.Free && !location.pathname.includes("plans")) {
        setKeyDriveDialog(true);
      }
    }
  }, [location.pathname, profile]);
  
  function resetIdSelected()
  {
    setIdSelectd(undefined);
  }

  Api.interceptors.response.use(
    function (config: AxiosRequestConfig) {
      return config;
    },
    function (error: any) {
      if (error != undefined) {
        let errorJson = error.toJSON();
        if (errorJson.status == 401) {
          auth.logout();
          if (!auth.token) {
            navegate("/login");
          }
        }
      }
      return Promise.reject(error);
    });

  useEffect(() => {
    if (nameOrg != undefined) {
      GetOneOrganization(nameOrg)
        .then((message) => {
          if (message != null) {
            setOrganization(message);
          } else {
            setOrganization(undefined);
          }
        })
        .catch((error) => {
          setOrganization(undefined);
          setUsersVisible(false);
          setOrganizationVisible(false);
          setWorkspaceVisible(false);
          setGroupspaceVisible(false);
          setDocuemntTypeVisible(false);
          setValidationRuleVisible(false);
          setOrganization(undefined);
          setFileVisible(false);
          setFeedTrackerVisible(false);
          setUserPendencies("invisible");
        });
    } else {
      setOrganization(undefined);
      setUsersVisible(false);
      setOrganizationVisible(false);
      setWorkspaceVisible(false);
      setGroupspaceVisible(false);
      setDocuemntTypeVisible(false);
      setValidationRuleVisible(false);
      setFileVisible(false);
      setFeedTrackerVisible(false);
      setOrganization(undefined);
      setUserPendencies("invisible");
    }
    
    SetOrganizationNameLocalStorage(nameOrg);

    if (profile?.userPicture != "" || profile?.userPicture != undefined) {
      profile.setUserPicture(profile.userPicture!);
      profile.setUsername(profile.name!);
      profile.setUserphone(profile.phone!);
    } else {
      profile.setUserPicture("");
      profile.setUsername("");
      profile.setUserphone("");
    }
    
    if(nameOrg != undefined) 
    {
      AddOrganizationLocalStorage(nameOrg);
    } else 
    {
      RemoveOrganizationLocalStorage();
    }
    
  }, [nameOrg, profile.id]);

  useEffect(() => {
    if(organization != undefined)
    {
      let orgAdmin:boolean = false;
      let workspaceAdmin:boolean = false;
      let orgUser:boolean = false;
      if(profile.organizations != undefined)
      {
        for(let organization of profile.organizations)
        {
          if(nameOrg == organization.internalName)
          {
            if(organization.isUser == true)
            {
              orgUser = true;
            }
            if(organization.isAdmin == true)
            {
              orgAdmin = true;
            }

            if(organization.isAdminWorkspace == true)
            {
              workspaceAdmin = true;
            }

            if(organization.internalName && orgUser)
            {
              setUserPendencies("waiting");
              GetUserPendenciesBoolean(organization.internalName).then((message) =>{
                  if(message.isValid == false){
                    setUserPendencies("false");
                  }
                  else{
                    setUserPendencies("true");
                  }
              })  
              .catch(() => {
                setUserPendencies("invisible");
              })
            }

            break;
          }
        }
      }

      setFeedTrackerVisible(true);
      setOrganization(organization);
      setUsersVisible(profile.adminSystem == true || orgAdmin || workspaceAdmin);
      setGroupspaceVisible(orgAdmin || workspaceAdmin);
      setWorkspaceVisible(orgAdmin);
      setDocuemntTypeVisible(orgAdmin || workspaceAdmin);
      setValidationRuleVisible(orgAdmin || workspaceAdmin);
      setFileVisible(orgUser);
      setOrganizationVisible(profile.adminSystem == true || orgAdmin);
      setFeedTrackerVisible(true);
    }
  }, [organization]);


  useEffect(() => {
    if (profile.organizations?.length! > 0) {
      var userIncludedInSavedOrganization = profile.organizations?.flatMap(org => org.internalName).includes(nameOrg);
      if (!userIncludedInSavedOrganization && !location.pathname.includes("plans")) {
        RemoveOrganizationLocalStorage();
        RemoveWorkspaceLocalStorage();
        navegate("/");
      }
    }
  }, [nameOrg, profile]);
  
  useEffect(() => {
    if (auth.token && profile.login == undefined) {
      profile.create(auth.token)
        .catch((error) =>{
          auth.logout();
          navegate("/login");
        });
    }

    let interval = setInterval(() => {
      if(nameOrg != undefined)
      {
        CreateUserLoggedByOrg({ orgName: nameOrg });
      }
    }, 5000);

    return () => {
      clearInterval(interval);
    };

  }, [nameOrg]);

   useEffect(() => {
      if (profile.organizations && profile.organizations.length > 0) {
        const namesOrgsInternal = profile.organizations.map(org => org.internalName);
        const pathSegments = location.pathname.split("/");
        const hasValidOrg = namesOrgsInternal.some(orgName => pathSegments.includes(orgName!));
        if (!hasValidOrg) {
          navegate(`/${namesOrgsInternal[0]}`);
      }
    }
    }, [nameOrg]);

  useEffect(() => {
    let locationSplit:string[] = location.pathname.split("/");
    if(locationSplit.length >= 4 && locationSplit[2] == "wsallowed")
    {
      GetOneWorkSpace(locationSplit[3])
      .then((workspaceFound)=>{ 
        if(workspaceFound != null)
        {
          setWorkSpace(workspaceFound);
        }
      });
    }
    else if(locationSplit.length >= 5 && locationSplit[4] == "documentTypes")
    {
      GetOneWorkSpace(locationSplit[3])
      .then((workspaceFound)=>{ 
        if(workspaceFound != null)
        {
          setOrgWorkSpace(workspaceFound);
          setOrgValidationWorkSpace(undefined);
          setWorkSpace(undefined);
        }
      });
    }
    else if(locationSplit.length >= 5 && locationSplit[4] == "validationRule")
    {
      GetOneWorkSpace(locationSplit[3])
      .then((workspaceFound)=>{ 
        if(workspaceFound != null)
        {
          setOrgWorkSpace(undefined);
          setWorkSpace(undefined);
          setOrgValidationWorkSpace(workspaceFound);
        }
      });
    }
    else
    {
      setWorkSpace(undefined);
      setOrgWorkSpace(undefined);
      setOrgValidationWorkSpace(undefined);
    }

    if (location.pathname.includes("UserPendencies") || location.pathname.includes("tracker") || location.pathname.includes("wsallowed")) {
      setNewLayoutProtected(true);
      return;
    } else {
      setNewLayoutProtected(false);
    }

    if (location.pathname.includes("adminConsole")) {
      setIsAdminConsolePage(true)
    } else {
      setIsAdminConsolePage(false)
    }


  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname.includes("adminConsole")) {
      setIsAdminConsolePage(true)
    } else {
      setIsAdminConsolePage(false)
    }
  }, [location])

  if (auth.token == undefined) {
    const loginPageUrl = window.location.protocol + '//' + window.location.host + '/login';
    const fileFromCopiedLink = idFile;

    if (fileFromCopiedLink !== undefined) {
      const linkParams = "?link=" + 'file/' + fileFromCopiedLink;
      return <Navigate to={`/login` + linkParams} />;
    }

    if ( window.location.href !== loginPageUrl) {
      const currentPath = window.location.pathname;
      const currentSearch = window.location.search;

      if (currentPath !== '/login') {
        const linkParams = "?link=" + currentPath + currentSearch;
        return <Navigate to={`/login` + linkParams} />;
      }
    }

    return <Navigate to="/login" />;
  }

  if(profile.id == undefined)
  {
    return <WaitPage/>
  }

  function catchContentbar(contentForBar: ContentbarProps<ISelectList>[]){
   setContentbar(contentForBar)
  }

  function updateContentbar(){
   setHasBeenUpdated(!hasBeenUpdated);
  }

  function resetSearchboxFocus()
  {
    if (searchboxFocus)
    {
      setSearchboxFocus(false)
    }
  }

  const isAllowed = handleAllowed(true, "wsallowed", location);
  const useAdminLayout = isAllowed || isAdminConsolePage;
  const useNoPaddingLayout = newLayoutProtected;
  const mydataPage = location.pathname.includes("mydata");

  const mainClassName = useAdminLayout
    ? style.FormComp
    : useNoPaddingLayout
    ? `${style.FormComp}`
    : `${style.FormComp}`;

  function getFreePlan(): boolean {
    const plans = profile.signtureInformation?.currentPlan!;
    if (plans == KeydrivePlan.FREE) {
      return true;
    }

    return false;
  }

  function mainPageHandler() {
    if (mydataPage) {
      return style.FormComp2;
    }

    if (useAdminLayout) {
      return style.FormComp;
    } 

    if (!useAdminLayout && useNoPaddingLayout) {
      return style.FormComp;
    }

    return style.FormComp;
  }

  function returnMessageBySeverity() {
    switch(openUpdateMethodDialog.severity) {
      case 1:
        return {
          title: t("Signture.YourPaymentMethodNeedToBeUpdatedTitle"),
          content: t("Signture.YourPaymentMethodNeedToBeUpdatedContent")
        }
      case 2:
        return {
          title: t("Signture.YourPaymentMethodNeedToBeUpdatedTitle2"),
          content: t("Signture.YourPaymentMethodNeedToBeUpdatedContent2")
        }
      case 3:
        return {
          title: t("Signture.YourPaymentMethodNeedToBeUpdatedTitle3"),
          content: t("Signture.YourPaymentMethodNeedToBeUpdatedContent3")
        }
    }
  }

    async function handleUpdatePaymentMethod() {
        setLoadingModal(true);
        setOpenEditPaymentMethodModal(false);
        
        try {
            setLoadingStep('validating');
            await new Promise(resolve => setTimeout(resolve, 800));

            const cardElement = elements?.getElement(CardElement);
            const addressElement = elements?.getElement(AddressElement);
            const addressElValue = await addressElement?.getValue();

            if (!addressElValue?.complete) {
                setLoadingModal(false);
                setLoadingStep(null);
                setErrorModal(true);
                return;
            }

            setLoadingStep('creating-payment');
            await new Promise(resolve => setTimeout(resolve, 1000));

            const stripePmRequest = await stripe?.createPaymentMethod({
                card: cardElement!,
                type: "card",
                billing_details: {
                    email: profile?.login!,
                    address: {
                        city: addressElValue?.value.address.city,
                        country: addressElValue?.value.address.country,
                        line1: addressElValue?.value.address.line1,
                        line2: addressElValue?.value.address.line2,
                        postal_code: addressElValue?.value.address.postal_code,
                        state: addressElValue?.value.address.state
                    },
                    name: addressElValue?.value.name,
                    phone: addressElValue?.value.phone!
                }
            });

            if (stripePmRequest?.error != undefined) {
                setLoadingModal(false);
                setLoadingStep(null);
                setErrorModal(true);
                return;
            }

            setLoadingStep('processing');
            await new Promise(resolve => setTimeout(resolve, 1000));

            await UpdatePaymentMethodAsync({
                paymentMethodId: stripePmRequest?.paymentMethod?.id!,
                Address: {
                    city: addressElValue?.value.address.city!,
                    country: addressElValue?.value.address.country!,
                    line1: addressElValue?.value.address.line1!,
                    line2: addressElValue?.value.address.line2!,
                    postalCode: addressElValue?.value.address.postal_code!,
                    state: addressElValue?.value.address.state!,
                    phone: addressElValue?.value.phone!
                },
                needPayInvoices: true 
            });

            setLoadingStep('finalizing');
            await new Promise(resolve => setTimeout(resolve, 800));

            setLoadingStep('complete');
            await new Promise(resolve => setTimeout(resolve, 1000));

            setLoadingModal(false);
            setLoadingStep(null);
            setSuccessModal(true);
            
        } catch (error: any) {
            setLoadingModal(false);
            setLoadingStep(null);
            setErrorModal(true);
            console.error(error);
            setErrorMessage(error.response.data);
        }
    }

    const getLoadingSteps = () => {
        return [
            'Validando dados',
            'Criando método de pagamento',
            'Atualizando metodo de pagamento',
            'Finalizando',
        ];
    };

    const getCurrentStepIndex = () => {
        switch (loadingStep) {
            case 'validating': return 0;
            case 'creating-payment': return 1;
            case 'processing': return 2;
            case 'finalizing': return 3;
            case 'complete': return 4;
            default: return 0;
        }
    };

  return (
    <div
      onClick={resetSearchboxFocus}
    >
      <Navbar 
        Organization={organization} 
        Workspace={workSpace} 
        OrgWorkspace={orgWorkSpace} 
        OrgValidation={orgValidationWorkSpace}
        contentbar={contentbar}
        updateContentbar={updateContentbar}
        resetIdSelected={resetIdSelected}
        searchMode={window.location.pathname.endsWith("/temporality/") ? SearchMode.Temporality : SearchMode.None}
        isCollapsed={isCollapsed}
        searchboxFocus={searchboxFocus}
        setSearchboxFocus={setSearchboxFocus}
        loadSignture={loadSignture}
      />
        { getFreePlan() && (
          <FreeSoftwareAlert 
            isCollapsed={isCollapsed}
            nameOrg={nameOrg!}
          />
        ) }
        { profile?.signtureInformation?.cancelAt != null && (
          <CancelDueAlert 
            isCollapsed={isCollapsed}
            nameOrg={nameOrg!}
          />
        ) }
      <main className={style.headerMain}>
        <SideBar
          isCheckedInitial={true}
          isOrganizationVisible={isOrganizationVisible}
          idOrganization={organization?.id}
          isWorkspaceVisible={isWorkspaceVisible}
          isUsersVisible={isUsersVisible}
          isGroupspaceVisible={isGroupspaceVisible}
          isDocuemntTypeVisible={false}
          isValidationRuleVisible={isValidationRuleVisible}
          isFileVisible={fileVisible}
          idFeedTrackerVisible={feedTrackerVisible}
          idSharedItemVisible={sharedItemVisible}
          isUserPendencies={isUserPendencies}
          internalName={organization?.internalName}
          catchContentbar={catchContentbar}
          hasBeenUpdated={hasBeenUpdated}
          idSelectd={idSelectd}
          setIdSelectd={setIdSelectd}
          organizations={profile?.organizations!}
          setIsCollapsed={setIsCollapsed}
          isAdminConsolePage={isAdminConsolePage}
          isCollapsed={isCollapsed}
        />
        <main 
          className={mainPageHandler()}   
          style={{
            marginTop: getFreePlan() ? "120px" : undefined
          }}
        >
          <Outlet />
        </main>
      </main>
      <FileUploader/>
        
      { openEditPaymentMethodModal && (
        <KeyDriveDialog
            hidden={
                loadingModal || successModal || errorModal
            }
            keyDriveDialogButtons={{
                rightButtonMethod: () => {
                    setOpenEditPaymentMethodModal(false);
                    handleUpdatePaymentMethod();
                },
                rightButtonText: t("Signture.SetupNewPaymentMethod")
            }}
            keyDriveDialogContent={{
                dialogContent: (
                  <>
                  <Box sx={{ mb: 3 }}>
                      <KeyDriveBodyMin 
                          color='#0a1929'
                          needBold={true}
                          needEllipses={false}
                          text='Dados do Cartão'
                      />
                      <Paper 
                          elevation={0} 
                          sx={{ 
                              p: 2.5, 
                              mt: 1.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 2,
                              '&:focus-within': {
                                  borderColor: '#22638D',
                                  boxShadow: '0 0 0 2px rgba(34, 99, 141, 0.1)'
                              }
                          }}
                      >
                          <CardElement 
                              options={{
                                  style: {
                                      base: {
                                          fontSize: "16px",
                                          color: "#0a1929",
                                          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                                          "::placeholder": {
                                              color: "#9e9e9e",
                                          },
                                      },
                                      invalid: {
                                          color: "#d32f2f",
                                      },
                                  },
                                  hidePostalCode: true,
                              }}
                          />
                      </Paper>
                  </Box>

                  <Box>
                      <KeyDriveBodyMin 
                          color='#0a1929'
                          needBold={true}
                          needEllipses={false}
                          text='Endereço de Cobrança'
                      />
                      <Paper 
                          elevation={0} 
                          sx={{ 
                              p: 2.5, 
                              mt: 1.5,
                              border: '1px solid #e0e0e0',
                              borderRadius: 2,
                              '& .StripeElement': {
                                  padding: 0,
                              }
                          }}
                      >
                          <AddressElement 
                            options={{
                              allowedCountries: ["BR", "US"],
                              mode: "billing",
                              fields: {
                                  phone: "always",
                              },
                              display: {
                                  name: "full",
                              },
                              autocomplete: {
                                  mode: "disabled",
                              },
                              defaultValues: {
                                  address: {
                                      country: "",
                                      city: "",
                                      line1: "",
                                      line2: "",
                                      postal_code: "",
                                      state: ""
                                  },
                                  firstName: "",
                                  lastName: "",
                                  name: "",
                                  phone: ""
                              },
                              validation: {
                                  phone: {
                                      required: "never"
                                  }
                              }
                            }}
                          />
                      </Paper>
                  </Box>
                  </>
                ),
                dialogIcon: <Payment sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
                dialogTitle:  returnMessageBySeverity()?.title,
                handleTogglDialog: () => {},
                openDialog: openEditPaymentMethodModal
            }}
            dialogTitleCenter
        />
      ) }

       <KeyDriveDialog 
          keyDriveDialogButtons={{
              leftButtonMethod: () => { setUpdateMethodDialog({ ...openUpdateMethodDialog, open: false }) },
              rightButtonMethod: () => {
                  setOpenEditPaymentMethodModal(true);
                  setUpdateMethodDialog({ ...openUpdateMethodDialog, open: false });
              },
              rightButtonText: t("Signture.SetupNewPaymentMethod"),
              leftButtonText: t("Signture.UpdatePaymentMethodLater")
          }}
          keyDriveDialogContent={{
              dialogContent: returnMessageBySeverity()?.content,
              dialogIcon: <Payment sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
              dialogTitle:  returnMessageBySeverity()?.title,
              handleTogglDialog: () => {},
              openDialog: openUpdateMethodDialog.open
          }}
          dialogTitleCenter
      />

      <KeyDriveDialog 
          keyDriveDialogButtons={{
              leftButtonMethod: () => { setCancelKeyDriveDialog(false) },
              rightButtonMethod: () => {
                setCancelKeyDriveDialog(false);
                let organizationInternalName = nameOrg;

                if (
                  !organizationInternalName &&
                  profile?.organizations?.[0]?.internalName
                ) {
                  organizationInternalName = profile.organizations[0].internalName;
                }

                navegate(`${organizationInternalName}/adminConsole/plans`);
              },
              rightButtonText: t("AdminConsole.FreeTier.AccessPlans"),
          }}
          keyDriveDialogContent={{
              dialogContent: t("Signture.SigntureCanceledContent"),
              dialogIcon: <Unsubscribe sx={{ color: "#22638D", width: "44px", height: "44px" }}/>,
              dialogTitle:  t("Signture.SigntureCanceledTitle"),
              handleTogglDialog: () => {},
              openDialog: openCancelKeyDriveDialog
          }}
          dialogTitleCenter
      />

      <KeyDriveDialog 
          keyDriveDialogButtons={{
              leftButtonMethod: () => {},
              rightButtonMethod: () => {},
              rightButtonText: undefined,
              leftButtonText: undefined
          }}
          keyDriveDialogContent={{
              dialogContent: (
                  <Box sx={{ 
                      textAlign: 'center',
                      py: 2
                  }}>
                      <KeyDriveBodyMax 
                          color='#0a1929'
                          needBold={true}
                          needEllipses={false}
                          text='Processando seu novo método de pagamento'
                      />
                      <Box sx={{ mt: 4, mb: 2, px: 2 }}>
                          <Stepper activeStep={getCurrentStepIndex()} alternativeLabel>
                              {getLoadingSteps().map((label) => (
                                  <Step key={label}>
                                      <StepLabel>{label}</StepLabel>
                                  </Step>
                              ))}
                          </Stepper>
                      </Box>
                      <LinearProgress 
                          sx={{ 
                              mt: 3,
                              height: 8,
                              borderRadius: 4,
                              bgcolor: '#e0e0e0',
                              '& .MuiLinearProgress-bar': {
                                  bgcolor: '#22638D'
                              }
                          }} 
                      />
                  </Box>
              ),
              handleTogglDialog: () => {},
              openDialog: loadingModal
          }}
      />

      <KeyDriveDialog 
          keyDriveDialogButtons={{
              leftButtonMethod: () => {},
              rightButtonMethod: () => {
                  setSuccessModal(false);
                  auth.logout();
              },
              rightButtonText: "Clique para sair e atualizar",
              leftButtonText: undefined
          }}
          keyDriveDialogContent={{
              dialogContent: (
                  <Box sx={{ 
                      textAlign: 'center',
                      py: 2
                  }}>
                      <Box sx={{
                          width: 80,
                          height: 80,
                          borderRadius: '50%',
                          bgcolor: '#e8f5e9',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          margin: '0 auto 24px'
                      }}>
                          <CheckCircle sx={{ color: "#4caf50", width: "56px", height: "56px" }} />
                      </Box>
                      
                      <KeyDriveBodyMax 
                          color='#0a1929'
                          needBold={true}
                          needEllipses={false}
                          text='Metodo de pagamento atualizado com sucesso!'
                      />
                      
                      <Box sx={{ mt: 2, mb: 3 }}>
                          <KeyDriveBodyMin 
                              color='#546e7a'
                              needBold={false}
                              needEllipses={false}
                              text='Seu metodo de pagamento foi atualizado com sucesso. Agradecemos por continuar com a KeyDrive.'
                          />
                      </Box>
                  </Box>
              ),
              handleTogglDialog: () => {},
              openDialog: successModal
          }}
      />

      <KeyDriveDialog 
        keyDriveDialogButtons={{
            leftButtonMethod: () => {},
            rightButtonMethod: () => {
                setErrorModal(false);
                setOpenEditPaymentMethodModal(true);
            },
            rightButtonText: "Tentar novamente",
            leftButtonText: undefined
        }}
        keyDriveDialogContent={{
            dialogContent: (
                <Box sx={{ 
                    textAlign: 'center',
                    py: 2
                }}>
                    <Box sx={{
                        width: 80,
                        height: 80,
                        borderRadius: '50%',
                        bgcolor: '#ffebee',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto 24px'
                    }}>
                        <Box sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '50%',
                            border: '4px solid #d32f2f',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            position: 'relative'
                        }}>
                            <Box sx={{
                                width: 4,
                                height: 24,
                                bgcolor: '#d32f2f',
                                borderRadius: 1,
                                transform: 'rotate(45deg)',
                                position: 'absolute'
                            }} />
                            <Box sx={{
                                width: 4,
                                height: 24,
                                bgcolor: '#d32f2f',
                                borderRadius: 1,
                                transform: 'rotate(-45deg)',
                                position: 'absolute'
                            }} />
                        </Box>
                    </Box>
                    
                    <KeyDriveBodyMax 
                        color='#0a1929'
                        needBold={true}
                        needEllipses={false}
                        text='Erro ao processar seu novo método de pagamento'
                    />

                    { errorMessage != undefined && (
                        <KeyDriveBodyMin 
                            color='#0a1929'
                            needBold={true}
                            needEllipses={false}
                            text={errorMessage}
                            sxStyles={{
                                mt: 2,
                            }}
                        />
                    ) }

                    <Paper 
                        elevation={0} 
                        sx={{ 
                            p: 3, 
                            mt: 3,
                            bgcolor: '#fff3e0',
                            border: '1px solid #ff9800',
                            borderRadius: 2,
                            textAlign: 'left'
                        }}
                    >
                        <KeyDriveBodyMin 
                            color='#e65100'
                            needBold={true}
                            needEllipses={false}
                            text='O que fazer agora?'
                        />
                        <Box sx={{ mt: 1.5 }}>
                            <KeyDriveBodyMin 
                                color='#5d4037'
                                needBold={false}
                                needEllipses={false}
                                text='• Verifique os dados do cartão e tente novamente'
                            />
                        </Box>
                        <Box sx={{ mt: 0.5 }}>
                            <KeyDriveBodyMin 
                                color='#5d4037'
                                needBold={false}
                                needEllipses={false}
                                text='• Certifique-se de que todos os campos estão preenchidos corretamente'
                            />
                        </Box>
                        <Box sx={{ mt: 0.5 }}>
                            <KeyDriveBodyMin 
                                color='#5d4037'
                                needBold={false}
                                needEllipses={false}
                                text='• Se o problema persistir, entre em contato com o suporte'
                            />
                        </Box>
                    </Paper>
                </Box>
            ),
            handleTogglDialog: () => {},
            openDialog: errorModal
        }}
      />
    </div>
  );
};

export default ILayoutProtected;
